export const defaultPermissions = [
    'DOCUMENT.DELETE_MASTER',
    'DOCUMENT.ADVANCED_SITE_SETTINGS',
    'DOCUMENT.EDIT_DESIGN_AND_LAYOUT',
    'DOCUMENT.EDIT_STRUCTURE',
    'DOCUMENT.EDIT_CONTENT',
    'EDITORX.ACCOUNT_MANAGE_LIBRARIES',
    'DOCUMENT.EDIT_ALT_TXT',
    'DOCUMENT.EDIT_PAGE_SEO',
    'EDITORX.EDIT_BASIC',
    'EDITORX.INSPECTOR_BUTTON',
    'EDITORX.GRANT_PAGE_EDIT',
    'EDITORX.DEV_MODE',
    'EDITORX.CONTENT_MANAGER',
    'WIX_DATA.FIND',
    'WIX_DATA.INSERT',
    'APP_MARKET.INSTALL_APP',
    'APP_MARKET.UNINSTALL_APPS',
    'pro-gallery.manage',
    'SIDEBAR.ENABLE-BLOG-POSTS',
    'SIDEBAR.VIEW-BLOG-POSTS',
    'SIDEBAR.VIEW-BLOG-PUBLISHED',
    'SIDEBAR.ENABLE-BLOG-PUBLISHED',
    'BLOG.EDIT-SETTINGS',
    'wix-stores.manage-store',
    'bookings.manage-services',
    'SIDEBAR.VIEW-SITE-MEMBERS',
    'wix-events.manage',
    'SIDEBAR.VIEW-FORUM',
    'SIDEBAR.ENABLE-FORUM',
    'WIX_FORUM.FORUM_EDIT',
    'SOCIAL-GROUPS.MANAGE',
    'SIDEBAR.ENABLE-CHALLANGES',
    'CHAT.MANAGE_CHAT',
    'crm-inbox.manage',
    'crm-inbox.settings',
    'WIX_CHAT.SETTINGS',
    'paid-plans.manage',
    'art-store.manage',
    'ALBUMS.MANAGE',
    'html-editor.save',
    'html-editor.publish',
    'SIDEBAR.ENABLE-RELEASE-MANAGER-SETTINGS',
    'site-actions.duplicate-site',
    'site-actions.transfer-site',
    'my-account.upgrade-site',
    'SIDEBAR.ENABLE-GENERAL-INFO',
    'my-account.open-dashboard',
    'WIX_RESTAURANTS.MANAGE_PERMISSION',
    'html-editor.view-revisions',
    'account-manager.view-domains-on-sidebar',
    'my-account.view-domains',
    'my-account.view-mailboxes',
    'account-manager.view-mailboxes-on-sidebar',
    'cashier.manage',
    'wix-seo.manage',
    'SIDEBAR.ENABLE-SOCIAL-POSTS',
    'SIDEBAR.ENABLE-NOTIFICATION-SETTINGS',
    'SIDEBAR.ENABLE-ROLES-AND-PERMISSIONS-SETTINGS',
    'SIDEBAR.ENABLE-INBOX',
    'SIDEBAR.VIEW-INBOX',
    'SIDEBAR.VIEW-STORES-PRODUCTS',
    'SIDEBAR.VIEW-STORES-PAYMENTS',
    'SIDEBAR.ENABLE-STORES-PRODUCTS',
    'SIDEBAR.ENABLE-STORES-PAYMENTS',
    'Account.AddTeamMember',
    'dashboard.view-analytics-widget',
    'site-actions.create-site',
    'PREMIUM_MANAGEMENT_SUBSCRIPTIONS.SUBSCRIPTIONS_LIST',
    'WIX_VIDEO.MANAGE_LIBRARY',
    'WIX-MUSIC.MANAGE-LIBRARY',
    'account-manager.view-vouchers-on-sidebar',
    'account-manager.view-billing-on-sidebar',
    'premium.manageDomains',
    'SIDEBAR.ENABLE-SITE-MEMBERS',
    'SIDEBAR.ENABLE-CRM-HOME',
    'SIDEBAR.ENABLE-PROMOTE-HOME',
    'site-users.send-invite',
    'EDITORX.INSPECTOR_TAB_LAYOUT_AND_DESIGN',
    'EDITORX.INSPECTOR_TAB_CONTENT',
    'EDITORX.NEW_COMMENT',
    'DOCUMENT.EDIT_DESIGN_AND_LAYOUT',
    'DOCUMENT.EDIT_SPECIFIC_PAGES',
    'EDITORX.ENFORCE_PRESENCE_VISIBILITY',
    'WIX_MULTILINGUAL.TRANSLATE_APPS',
    'my-account.rename-site',
];
export const Permissions = defaultPermissions.reduce((accPermissions, permission) => {
    accPermissions[permission] = permission;
    return accPermissions;
}, {});
export const UrlPermissionValuesDivider = ':';
//# sourceMappingURL=permissions.js.map